import {
  Box,
  Button,
  Flex,
  Input,
  Stack,
  Text,
  useBreakpointValue,
  useColorModeValue,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { FaJs, FaLaptopCode, FaNodeJs, FaReact } from "react-icons/fa";
import { GiStethoscope } from "react-icons/gi"; // New icon for medical systems
import { SiMongodb, SiTypescript } from "react-icons/si";

const Home = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const iconSize = useBreakpointValue({ base: "2em", md: "3em" });

  const textColor = useColorModeValue("gray.800", "whiteAlpha.900");
  const bgColor = useColorModeValue("gray.100", "gray.700");
  const bgImage = "url(https://source.unsplash.com/1600x900/?medical)";

  // Load name and title from localStorage when the component mounts
  useEffect(() => {
    const storedName = localStorage.getItem("name") || "Joabe Nascimento";
    const storedTitle =
      localStorage.getItem("title") || "Desenvolvedor FullStack Jr.";
    setName(storedName);
    setTitle(storedTitle);
  }, []);

  // Save name and title to localStorage
  const handleSave = () => {
    localStorage.setItem("name", name);
    localStorage.setItem("title", title);
    setIsEditing(false);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <Box
        bgImage={bgImage}
        bgSize="cover"
        bgPosition="center"
        minH="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        color={textColor}
        textAlign="center"
        py={10}
        px={6}
        position="relative"
        overflow="hidden"
        mt={16}
        bgColor={bgColor}
      >
        <motion.div
          initial={{ y: -200 }}
          animate={{ y: 0 }}
          transition={{ duration: 1, type: "spring", stiffness: 100 }}
          style={{
            position: "absolute",
            top: "-50%",
            left: "50%",
            width: "200%",
            height: "200%",
            filter: "blur(30px)",
            zIndex: -1,
          }}
        />
        <Flex direction="column" alignItems="center">
          <Stack direction="row" spacing={2} alignItems="center">
            <Text fontSize="4xl" fontWeight="800" mb={4}>
              SysTech Softwares
            </Text>
          </Stack>
          <Stack direction="row" spacing={6} mb={12}>
            <motion.div
              whileHover={{ scale: 1.2, rotate: 10 }}
              whileTap={{ scale: 0.9 }}
            >
              <FaReact size={iconSize} color="#61DAFB" />
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.2, rotate: 10 }}
              whileTap={{ scale: 0.9 }}
            >
              <SiMongodb size={iconSize} color="#47A248" />
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.2, rotate: 10 }}
              whileTap={{ scale: 0.9 }}
            >
              <FaNodeJs size={iconSize} color="#68A063" />
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.2, rotate: 10 }}
              whileTap={{ scale: 0.9 }}
            >
              <FaJs size={iconSize} color="#F7DF1E" />
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.2, rotate: 10 }}
              whileTap={{ scale: 0.9 }}
            >
              <SiTypescript size={iconSize} color="#007ACC" />
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.2, rotate: 10 }}
              whileTap={{ scale: 0.9 }}
            >
              <GiStethoscope size={iconSize} color="#FF6347" />
            </motion.div>
          </Stack>
          {isEditing ? (
            <>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Name"
                mb={4}
              />
              <Input
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Title"
                mb={4}
              />
              <Button
                colorScheme="teal"
                onClick={handleSave}
                as={motion.button}
                whileHover={{ scale: 1.1, backgroundColor: "#319795" }}
                whileTap={{ scale: 0.9 }}
                transition={{ duration: 0.2 }}
              >
                Save
              </Button>
            </>
          ) : (
            <>
              <Text
                fontSize="2xl"
                mb={4}
                as={motion.p}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.7 }}
              >
                {name}
              </Text>

              <Text
                fontSize="1.3rem"
                fontWeight="bold"
                mb={4}
                as={motion.p}
                initial={{ y: 200 }}
                animate={{ y: 0 }}
                transition={{ duration: 0.7, type: "spring", stiffness: 100 }}
              >
                {title}
              </Text>

              <Button
                colorScheme="teal"
                onClick={() => setIsEditing(true)}
                mb={4}
                as={motion.button}
                whileHover={{ scale: 1.1, backgroundColor: "#319795" }}
                whileTap={{ scale: 0.9 }}
                transition={{ duration: 0.2 }}
                leftIcon={<FaLaptopCode />}
              >
                Developer Mode
              </Button>
            </>
          )}
        </Flex>
      </Box>
    </motion.div>
  );
};

export default Home;
